import type { PocSummaryResponse } from '../service/ApiService';

export type PhaseFilter = 'ALL' | 'INITIATION' | 'PREPARATION' | 'RUNNING' | 'EVALUATION';

export const PHASE_FILTERS: { id: PhaseFilter; label: string }[] = [
  { id: 'ALL', label: 'All' },
  { id: 'INITIATION', label: 'Initiation' },
  { id: 'PREPARATION', label: 'Preparation' },
  { id: 'RUNNING', label: 'Running' },
  { id: 'EVALUATION', label: 'Evaluation' },
];

/** First work screen for each phase (exact in-step resume needs GET /pocs/{id} later). */
export function resumePathForPhase(phase: string): string {
  switch (phase) {
    case 'INITIATION':
      return '/pocs/new/business-justification';
    case 'PREPARATION':
      return '/pocs/new/preparation/success-criteria';
    case 'RUNNING':
      return '/pocs/new/running/workspace';
    case 'EVALUATION':
      return '/pocs/new/evaluation/workspace';
    default:
      return '/pocs/new/business-justification';
  }
}

export function formatLabel(value: string | undefined | null): string {
  if (!value) return '—';
  return value
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function shortId(id: string): string {
  return id.length > 8 ? `${id.slice(0, 8)}…` : id;
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function isOwnPoc(
  poc: PocSummaryResponse,
  signedInEmail: string | undefined
): boolean {
  if (!signedInEmail || !poc.requestorEmail) return false;
  return poc.requestorEmail.trim().toLowerCase() === signedInEmail.trim().toLowerCase();
}

export function matchesPocSearch(
  poc: PocSummaryResponse,
  idQuery: string,
  nameQuery: string,
  requestorQuery?: string
): boolean {
  const idOk =
    !idQuery || poc.id.toLowerCase().includes(idQuery.trim().toLowerCase());
  const nameOk =
    !nameQuery ||
    (poc.title ?? '').toLowerCase().includes(nameQuery.trim().toLowerCase());
  const requestorOk =
    !requestorQuery ||
    (poc.requestorName ?? '')
      .toLowerCase()
      .includes(requestorQuery.trim().toLowerCase()) ||
    (poc.requestorEmail ?? '')
      .toLowerCase()
      .includes(requestorQuery.trim().toLowerCase());
  return idOk && nameOk && requestorOk;
}
